import { useMemo } from "react";

export const useDropdownImageSize = (imageDropdownSize: string, S: { [key: string]: string }) => {
    //Image size from dropdown in Umbraco
    //imageSmall === 25%
    //imageMedium === 50%
    //imageLarge === 100%

    const imageDropdownSizeClass = useMemo(() => {
        switch (imageDropdownSize) {
            case "25%":
                return S.imageSmall;
            case "50%":
                return S.imageMedium;
            case "100%":
                return S.imageLarge;
            default:
                return S.imageLarge; // Default case
        }
    }, [imageDropdownSize, S]);

    return {
        imageDropdownSizeClass,
    };
};
